import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { useInterval } from '../../hooks/useInterval';
import { imageEntityPropShape } from './shapes/imageEntityPropShape';
import { Image } from './Image';

export const AnimatedImage = props => {
  const { entities, addSchema, aspect, quality, maxWidths, loading, noStyle } =
    props;
  const filteredEntities = entities.filter(entity => !!entity.entity?.uuid);

  const [activeImage, setActiveImage] = useState(0);
  const [animationMustStart, setAnimationMustStart] = useState(false);
  const changeImage = () => {
    if (!filteredEntities[activeImage + 1]) {
      setActiveImage(0);
    } else {
      setActiveImage(activeImage + 1);
    }
  };
  const imageOnLoadHandler = () => {
    setAnimationMustStart(true);
  };
  useInterval(changeImage, animationMustStart ? 2000 : null);

  return (
    <>
      {filteredEntities.map((entity, index) => {
        if (index === 0) {
          return (
            <div
              css={css`
                display: ${index === activeImage ? 'block' : 'none'};
              `}
              key={entity.entity.uuid}
            >
              <Image
                entity={entity.entity}
                addSchema={addSchema}
                aspect={aspect}
                quality={quality}
                maxWidths={maxWidths}
                loading={loading}
                noStyle={noStyle}
                onLoad={imageOnLoadHandler}
                fade={false}
              />
            </div>
          );
        }
        return (
          <div
            css={css`
              display: ${index === activeImage ? 'block' : 'none'};
            `}
            key={entity.entity.uuid}
          >
            <Image
              entity={entity.entity}
              addSchema={addSchema}
              aspect={aspect}
              quality={quality}
              maxWidths={maxWidths}
              loading="eager"
              noStyle={noStyle}
              fade={false}
            />
          </div>
        );
      })}
    </>
  );
};

AnimatedImage.defaultProps = {
  entities: undefined,
  aspect: undefined,
  quality: undefined,
  addSchema: false,
  maxWidths: {},
  loading: 'lazy',
  noStyle: false
};

AnimatedImage.propTypes = {
  entities: PropTypes.arrayOf(
    PropTypes.shape({ entity: imageEntityPropShape })
  ),
  addSchema: PropTypes.bool,
  aspect: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.objectOf(PropTypes.string)
  ]),
  quality: PropTypes.number,
  maxWidths: PropTypes.shape({
    mobile: PropTypes.number,
    tablet: PropTypes.number,
    small_desktop: PropTypes.number,
    large_desktop: PropTypes.number
  }),
  loading: PropTypes.oneOf(['eager', 'lazy']),
  noStyle: PropTypes.bool
};
